import * as React from 'react';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import { StylesProps } from 'theme/jss-types';
import { formFields } from 'components/create-consignment/create-modal.constants';
import { useTranslation } from 'react-i18next';
import {
    Col,
    Form,
    FormInstance,
    Select,
} from 'antd';
import { ModeType } from 'types/master-data-types';

const styles = () => ({
    formItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        '& .ant-checkbox + span': {
            color: '#111111',
            fontSize: 14,
            fontWeight: 600,
        },
    },
    title: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
        marginLeft: 4,
    },
    amount: {
        display: 'flex',
        flexDirection: 'column',
    },
    label: {
        color: '#333333',
        fontSize: 12,
    },
});

interface IProps extends StylesProps<ReturnType<typeof styles>>, ReturnType<typeof mapStateToProps> {
    form: FormInstance;
    params: any;
}

const CODModeField = (props: IProps) => {
    const { t } = useTranslation();
    const {
        classes,
        form,
        modeTypes,
        params,
    } = props;
    const {
        ConsignmentCategory,
        IsCOD,
        Mode,
    } = formFields;

    const { getValidationRules, getIsRequiredValidation, disabledFields = {} } = params;

    const consignmentCategory = Form.useWatch(ConsignmentCategory.key, form);
    const isCodValue = Form.useWatch(IsCOD.key, form);

    if (consignmentCategory === 'international') return <></>;
    if (isCodValue && isCodValue === 'no') return <></>;

    const options = modeTypes.map((mode) => {
        return (
            <Select.Option key={mode} value={mode}>
                {t(mode)}
            </Select.Option>
        );
    });
    return (
        <Col span={24} xs={24} sm={24} md={12}>
            <span className={classes.label}>
                {t('codCollectionMode')}
                {getIsRequiredValidation(Mode.key) && '*'}
            </span>
            <Form.Item
                name={Mode.key}
                initialValue={Mode.defaultValue}
                valuePropName={Mode.valuePropName}
                className={classes.amount}
                rules={getValidationRules(Mode)}
            >
                <Select
                    allowClear
                    placeholder={t('mode_placeholder')}
                    disabled={!!disabledFields[Mode.key]}
                >
                    {options}
                </Select>
            </Form.Item>
        </Col>
    );
};

const mapStateToProps = (state: any) => {
    const { master } = state;
    const { config } = master;
    const modeInfo: ModeType[] = config.customer_portal_config?.cod_collection_mode_list || [];
    const modeTypes: string[] = modeInfo.map((mode) => {
        return mode.name;
    });
    return {
        modeTypes: modeTypes.length ? modeTypes : ['Cash'],
    };
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectJss: {
        useJss: true,
        styleSheet: styles,
    },
};

export default GenericHoc(hocConfig)(CODModeField);
